import { style, styleVariants } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Inline status chip. Pairs a tinted surface with a darker on-surface
// text color from the same status family — readable at small sizes
// without relying on alpha compositing.
const base = style({
  display: "inline-flex",
  alignItems: "center",
  gap: vars.space.xs,

  fontFamily: vars.font.body,
  fontSize: vars.fontSize.xs,
  fontWeight: vars.fontWeight.semibold,
  lineHeight: vars.lineHeight.tight,
  letterSpacing: "0.02em",

  paddingBlock: "2px",
  paddingInline: vars.space.sm,
  borderRadius: vars.radius.full,
  borderWidth: "1px",
  borderStyle: "solid",

  whiteSpace: "nowrap",
});

export const badge = styleVariants({
  neutral: [
    base,
    {
      backgroundColor: vars.color.neutralSurface,
      borderColor: vars.color.neutralSurfaceBorder,
      color: vars.color.neutralOnSurface,
    },
  ],
  success: [
    base,
    {
      backgroundColor: vars.color.successSurface,
      borderColor: vars.color.successSurfaceBorder,
      color: vars.color.successOnSurface,
    },
  ],
  warning: [
    base,
    {
      backgroundColor: vars.color.warningSurface,
      borderColor: vars.color.warningSurfaceBorder,
      color: vars.color.warningOnSurface,
    },
  ],
  danger: [
    base,
    {
      backgroundColor: vars.color.dangerSurface,
      borderColor: vars.color.dangerSurfaceBorder,
      color: vars.color.dangerOnSurface,
    },
  ],
  info: [
    base,
    {
      backgroundColor: vars.color.infoSurface,
      borderColor: vars.color.infoSurfaceBorder,
      color: vars.color.infoOnSurface,
    },
  ],
  // Brand tints. Not statuses — these are for chips that name a position
  // in a sequence (pipeline stage, case phase) where a status color
  // would lie about outcome.
  navy: [
    base,
    {
      backgroundColor: vars.color.navySurface,
      borderColor: vars.color.navySurfaceBorder,
      color: vars.color.navyOnSurface,
    },
  ],
  olive: [
    base,
    {
      backgroundColor: vars.color.oliveSurface,
      borderColor: vars.color.oliveSurfaceBorder,
      color: vars.color.oliveOnSurface,
    },
  ],
});
